<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center my-5">
      <div class="col-11 col-md-5 mx-auto">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="-50"
            animateClass="animated"
            :begin="false"
          >
          <h2 class="serif col-blue ">
            Statement of Information
          </h2>
          <hr>
          </u-animate>
        </u-animate-container>
      </div>
    </div>
    <div class="row d-flex justify-content-center my-5">
      <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="-100"
          animateClass="animated"
          :begin="false"
        >
        <a :href="soi" class="soi-button" target="_blank">
          Statement of information
        </a>
        </u-animate>
      </u-animate-container>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Floorplan',
  components: {

  },
  data() {
    return {
      soi: '',
    }
  },
  created() {
    this.soi = this.$store.getters.getSOI
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.soi-button {
  vertical-align: middle;
  margin: 0 0 1rem;
  font-size: 12px;
  color: $blue;
  letter-spacing: 1px;
  padding: 15px 40px;
  border: 2px solid $blue;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  position: relative;
  transition: .3s;
}
</style>
